import {
  deleteAdminOrganisationByOrganisationIdGroupByGroupId,
  putAdminOrganisationByOrganisationIdGroupByGroupId,
  getAdminOrganisationByOrganisationIdGroupByGroupId
} from '@modv/sdk'
import BaseEntity from '../base-entity/index'
// eslint-disable-next-line no-unused-vars
import { Notification } from 'element-ui'

const baseEntity = new BaseEntity()

const state = {
  group: {},
  loading: false,
  ...baseEntity.state
}
const getters = {
  ...baseEntity.getters
}
const mutations = {
  ...baseEntity.mutations,
  set_loading(state, val) {
    state.loading = val
  },
  GET_GROUP: (state, res) => {
    state.group = res.data
  },
  UPDATE_GROUP: (state, res) => {
    state.group = res.data
  },
  DELETE_GROUP: (state, res) => {},
  ON_CHANGE_MODAL(state, res) {
    state.showDeleteModal = false
    state.showModal = res.visible
    state.folder = {}
  }
}
const actions = {
  ...baseEntity.actions,
  async delete({ commit, dispatch }, params) {
    dispatch(
      'organisation/removeGroup',
      {
        groupId: params.groupId
      },
      {
        root: true
      }
    )
    const res = await deleteAdminOrganisationByOrganisationIdGroupByGroupId({
      organisationId: params.organisationId,
      groupId: params.groupId
    })
    commit('DELETE_GROUP', res)
    if (res.status === 200) {
      Notification.success('Groups successfully removed.')
    } else {
      Notification.error('Failed to remove group.')
    }
  },
  async update({ commit, dispatch }, params) {
    const res = await putAdminOrganisationByOrganisationIdGroupByGroupId({
      groupId: params.groupId,
      organisationId: params.organisationId,
      name: params.name
    })
    commit('UPDATE_GROUP', res)
    if (res.status === 200) {
      dispatch(
        'organisation/updateGroup',
        {
          groupId: params.groupId,
          group: res.data
        },
        {
          root: true
        }
      )
      Notification.success('Group successfully updated.')
    } else {
      Notification.error('Failed to update group.')
    }
  },
  async get({ commit }, params) {
    commit('set_loading', true)
    commit(
      'GET_GROUP',
      await getAdminOrganisationByOrganisationIdGroupByGroupId({
        organisationId: params.organisationId,
        groupId: params.groupId
      })
    )
    commit('set_loading', false)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
